module.exports = __webpack_public_path__ + "static/media/note.f97d4705.svg";